import {PROTOCOL_SLIDE_TYPES} from '@learningblocks/protocol-constants/lib/Utilities';
import {updateInSlideThree} from '../../utilities';

export function slideThreeDragDrop(state, payload) {
  return {
    ...state,
    protocolSection: updateDesignSection(state.protocolSection, payload),
  };
}

function updateDesignSection(protocolSection, payload) {
  const updateInSlide = (slide) => {
    if (slide.type === PROTOCOL_SLIDE_TYPES.THREE) {
      slide = updateInSlideThree(slide, payload);
    }
    return slide;
  };

  return {
    ...protocolSection,
    allSlides: protocolSection.allSlides.map(updateInSlide),
  };
}
